module.exports = {"id":"214302","name":"Claudio Baeza","rating":"72","photo":"./data/images/photos/4/214302.png","club":{"name":"Colo-Colo","logo":"./data/images/clubs/Colo-Colo.png"},"positions":["MC","DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ClaudioBaeza0.json
// module id = 824
// module chunks = 0